/**
 * A rastreabilidade do projeto, portada de app.js:532-541.
 *
 * A linha do tempo é a procedência do acervo: cada doc nasceu de um commit, e é
 * esse par que o agente cita. O vazio daqui não manda reprocessar de propósito —
 * projeto recém-conectado não tem ingest nenhum para repetir.
 */
import { useCommits } from '../api/consultas';
import { Carregando, Falha, Vazio } from '../componentes/Estado';

export function Rastreabilidade({ slug }: { slug: string }) {
  const commits = useCommits(slug);

  if (commits.isPending) return <Carregando rotulo="a rastreabilidade" />;
  if (commits.error) {
    return <Falha erro={commits.error} rotulo="a rastreabilidade" aoRepetir={commits.refetch} />;
  }

  const lista = commits.data || [];

  return (
    <>
      <div className="crumb"><b>{slug}</b><span className="sep">/</span>rastreabilidade</div>
      <div className="sec-title">Rastreabilidade</div>
      <div className="sec-sub">Cada documento está amarrado ao commit que o gerou.</div>

      {lista.length ? (
        <div className="timeline">
          {lista.map((c, i) => (
            <div className="commit-row" key={`${c.sha_after || ''}-${i}`}>
              <span className="sha">{(c.sha_after || '').slice(0, 8)}</span>
              <div style={{ flex: 1 }}>
                <div><b>{c.message || '(sem mensagem)'}</b></div>
                <div className="meta">
                  {c.author || '—'} · {(c.committed_at || '').slice(0, 19).replace('T', ' ')} · modo {c.mode}
                </div>
              </div>
              <span className="pill done">{c.status}</span>
            </div>
          ))}
        </div>
      ) : (
        <Vazio titulo="Nenhum commit registrado ainda">
          O acervo deste projeto foi montado sem histórico de ingest — costuma acontecer em projeto
          recém-conectado ou carregado por bootstrap manual. A partir do próximo push, cada commit
          aparece aqui com o que ele mudou na documentação.
        </Vazio>
      )}
    </>
  );
}
